/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Disabled_BannerInputs */

const vi_tracking_disabled_banner = /** @type {(inputs: Tracking_Disabled_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tích hợp GPS chưa được kích hoạt. Liên hệ quản trị viên để cấu hình VnetGPS.`)
};

/**

* @param {Tracking_Disabled_BannerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_disabled_banner = /** @type {((inputs?: Tracking_Disabled_BannerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Disabled_BannerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_disabled_banner(inputs)
});